import React from "react";

const HomeIcon = () => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.8262 8.93281L10.6325 0.743301L10.0832 0.194082C9.9581 0.0697694 9.78887 0 9.61248 0C9.43609 0 9.26686 0.0697694 9.14172 0.194082L0.398749 8.93281C0.270522 9.06054 0.169183 9.21266 0.100712 9.38019C0.032241 9.54773 -0.00197343 9.72728 8.78955e-05 9.90826C0.00857004 10.6547 0.629887 11.2506 1.37632 11.2506H2.27754V18.1571H16.9474V11.2506H17.8677C18.2303 11.2506 18.5717 11.1085 18.8283 10.8519C18.9547 10.726 19.0548 10.5762 19.1228 10.4113C19.1909 10.2464 19.2256 10.0697 19.2249 9.89129C19.2249 9.5308 19.0828 9.1894 18.8262 8.93281ZM10.8 16.6304H8.42498V12.3045H10.8V16.6304ZM15.4206 9.72377V16.6304H12.1571V11.7955C12.1571 11.3269 11.7775 10.9473 11.3089 10.9473H7.91605C7.44741 10.9473 7.06783 11.3269 7.06783 11.7955V16.6304H3.80433V9.72377H1.76861L9.6146 1.88415L10.1044 2.37399L17.4585 9.72377H15.4206Z"
        fill="#3F3F3F"
      />
    </svg>
  );
};

export default HomeIcon;
